import apiClient from '../../apiClient';
import { Content, ContentResponse, KeyValue } from './type';

const fetchResourceData = async (): Promise<Content> => {
  const API_ENDPOINT = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_CONTENT_API_PATH}`;
  let response: ContentResponse;
  let contentData: KeyValue;
  try {
    response = await apiClient.get<ContentResponse>(API_ENDPOINT);
    contentData = response.success ? response.data : (await import('./localized-content-en.json')).default.data;
  } catch (e: any) {
    contentData = (await import('./localized-content-en.json')).default.data;
  }

  const images = Object.keys(contentData)
    .filter(function (k) {
      return k.indexOf('preview-sales-engine.static-content.images') === 0;
    })
    .reduce(function (newData, k) {
      // @ts-ignore
      newData[k] = contentData[k];
      return newData;
    }, {});

  const copy = Object.keys(contentData)
    .filter(function (k) {
      return k.indexOf('preview-sales-engine.static-content.copy') === 0;
    })
    .reduce(function (newData, k) {
      // @ts-ignore
      newData[k] = contentData[k];
      return newData;
    }, {});

  return {
    messages: copy,
    images: images,
  };
};

export default fetchResourceData;
